import { render, staticRenderFns } from "./WalletForCustomer.vue?vue&type=template&id=47ca2244&"
import script from "./WalletForCustomer.vue?vue&type=script&lang=js&"
export * from "./WalletForCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports